var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.218747 1.6253L3.71875 6.0003L0.218747 10.3753C0.136671 10.4779 0.0755992 10.5956 0.0390196 10.7217C0.00244005 10.8479 -0.00893146 10.98 0.00555447 11.1106C0.0200404 11.2412 0.0600999 11.3676 0.123446 11.4827C0.186792 11.5977 0.272184 11.6992 0.374747 11.7813C0.477309 11.8634 0.595033 11.9244 0.721198 11.961C0.847362 11.9976 0.979496 12.009 1.11006 11.9945C1.24061 11.98 1.36704 11.9399 1.48212 11.8766C1.5972 11.8132 1.69867 11.7279 1.78075 11.6253L5.78075 6.6253C5.92275 6.44793 6.00012 6.2275 6.00012 6.0003C6.00012 5.77309 5.92275 5.55266 5.78075 5.3753L1.78075 0.375296C1.61499 0.168162 1.37373 0.0353592 1.11006 0.00610353C0.846379 -0.0231521 0.581881 0.0535352 0.374747 0.219296C0.272184 0.301372 0.186792 0.402845 0.123446 0.517922C0.0601001 0.633 0.0200405 0.759428 0.0055546 0.889987C-0.0237011 1.15366 0.0529865 1.41816 0.218747 1.6253V1.6253Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.f3027cbf73f628bb2134c4d5cf761c1b.svg";
export { ForwardRef as ReactComponent };